import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { AuthProvider } from './hooks/useAuth'
import { CompanyProvider } from './hooks/useCompany'
import ProtectedRoute from './components/layout/ProtectedRoute'
import SellerRoute from './components/layout/SellerRoute'
import LoginPage from './pages/LoginPage'
import AyudaVentasPage from './pages/AyudaVentasPage'
import DashboardPage from './pages/DashboardPage'
import StatsPage from './pages/StatsPage'
import ProductosPage from './pages/ProductosPage'
import ProductosEstrellaPage from './pages/ProductosEstrellaPage'
import MenorRotacionPage from './pages/MenorRotacionPage'
import IndicadoresPage from './pages/IndicadoresPage'
import CostosPage from './pages/CostosPage'
import OrigenPage from './pages/OrigenPage'
import VendedoresPage from './pages/VendedoresPage'
import ResumenPage from './pages/ResumenPage'
import FinanzasPage from './pages/FinanzasPage'
import BuscadorPage from './pages/BuscadorPage'

function App() {
  return (
    <AuthProvider>
      <CompanyProvider>
      <BrowserRouter>
        <Routes>
          {/* Public routes */}
          <Route path="/login" element={<LoginPage />} />

          {/* Ayudaventas: accesible por vendedores y admins */}
          <Route element={<SellerRoute />}>
            <Route path="/ayudaventas" element={<AyudaVentasPage />} />
          </Route>

          {/* Protected routes (solo admin) */}
          <Route element={<ProtectedRoute />}>
            <Route path="/" element={<DashboardPage />} />
            <Route path="/stats" element={<StatsPage />} />
            <Route path="/productos" element={<ProductosPage />} />
            <Route path="/buscador" element={<BuscadorPage />} />
            <Route path="/productos/estrella" element={<ProductosEstrellaPage />} />
            <Route path="/productos/menor-rotacion" element={<MenorRotacionPage />} />
            <Route path="/indicadores" element={<IndicadoresPage />} />
            <Route path="/costos" element={<CostosPage />} />
            <Route path="/origen" element={<OrigenPage />} />
            <Route path="/vendedores" element={<VendedoresPage />} />
            <Route path="/resumen" element={<ResumenPage />} />
            <Route path="/finanzas" element={<FinanzasPage />} />
          </Route>

          {/* Fallback redirect */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
      </CompanyProvider>
    </AuthProvider>
  )
}

export default App
